// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__EZqgT","header":"Header_header__35zKk","separator":"Header_separator__3UuCJ"};